<template>
    <v-form @submit.prevent="addUpdate" ref="form">
        <v-card class="rounded-4">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold ">{{mode}} Cash Advance</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="form-container">
                <v-layout v-if="isRequestForOtherUser" row wrap>
                    <v-flex xs12 sm12 class="form-row">
                        <v-autocomplete
                            v-model="requestForUserId"
                            :disabled="disabled"
                            :items="employees"
                            :loading="loading_employees"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Request for Employee"
                            item-text="name"
                            item-value="userId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                <v-list-tile-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout row wrap> 
                    <v-flex xs12 sm6 class="form-row"> 
                        <v-text-field label="Cash Advance Amount" 
                            v-model="totalAmount" 
                            :disabled="disabled"
                            :rules="[rules.required_numeric,rules.max_amount]"
                            type="number" min="1" step="1" value="0.00" 
                            ></v-text-field>  
                    </v-flex>
                    <v-flex xs12 sm6 class="form-row"> 
                        <v-select
                            label="Type"
                            :items="cashadvances_types"
                            :rules="[rules.required]" 
                            item-text="cashAdvanceType"
                            item-value="cashAdvanceTypeId"
                            :disabled="disabled"
                            :loading="loading_types"
                            v-model="cashAdvanceTypeId"
                        ></v-select>
                    </v-flex>
                </v-layout>                
                <v-layout row wrap> 
                    <v-flex xs12 sm6 class="form-row"> 
                        <v-select
                            label="Calculate By"
                            :items="calculation_types"
                            :rules="[rules.required]" 
                            item-text="description"
                            item-value="calculationType"
                            :disabled="disabled"
                            v-model="calculationType"
                        ></v-select>
                    </v-flex>
                    <v-flex v-if="calculationType==2" xs12 sm6 class="form-row"> 
                        <v-text-field label="Monthly Deduction Amount" 
                            v-model="monthlyDeductionAmount" 
                            :disabled="disabled"
                            :rules="[rules.required_numeric,rules.max_amount]"
                            type="number" min="1" step="1" value="0.00" 
                            ></v-text-field>  
                    </v-flex>
                    <v-flex v-if="calculationType==1" xs12 sm6 class="form-row"> 
                        <v-text-field label="Number of months to pay" 
                            v-model="paymentTerms" 
                            :disabled="disabled"
                            :rules="[rules.required_numeric, rules.max_months_to_pay]"
                            type="number" min="1" step="1" value="0.00" 
                            ></v-text-field> 
                    </v-flex>
                    <v-flex xs12 sm6 class="form-row"> 
                        <v-menu v-model="menuPaymentStart" :close-on-content-click="false" :nudge-right="40"
                            lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="paymentStart" label="Payment Start Month" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                            </template>
                            <v-date-picker no-title type="month" v-model="paymentStart" :allowed-dates="allowedDates" @input="menuPaymentStart = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex v-if="isBiMonthlyCutoff" xs12 sm6 class="form-row">
                        <v-select
                            label="Payment Start CutOff"
                            :items="payment_start_cutoff"
                            :rules="[rules.required]"
                            item-text="description"
                            item-value="cutOff"
                            :disabled="disabled"
                            v-model="paymentCutOffStart"
                        ></v-select>
                    </v-flex>
                    <v-flex v-if="isBiMonthlyCutoff" xs12 sm6 class="form-row"> 
                        <v-select
                            label="Deduction Mode"
                            :items="getPayoutTypes"
                            :rules="[rules.required]" 
                            item-text="description"
                            item-value="payoutMode"
                            :disabled="disabled"
                            v-model="deductionMode"
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout v-if="showComment" row wrap> 
                    <v-flex xs12 sm12 class="form-row"> 
                        <v-textarea v-model="description" label="Comments" rows="1" color="primary"></v-textarea>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon @click="showComment=!showComment" title="Add Comment">
                    <v-icon>comment</v-icon>
                </v-btn>
                <v-btn v-if="mode!='Update'" @click="clearForm" :disabled="disabled" >Clear</v-btn>
                <v-btn color="primary" type="submit" :disabled="disabled" :loading="loading" dark class="mr-25">{{mode}}</v-btn>                
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import cashadvancesApi from '@/api/cashadvances'
import cutoffApi from '@/api/cutoff'
import employeeApi from '@/api/employees'
import awsS3Helper from '@/helpers/aws-s3'
import pageKeys from '@/common/pagekeys'
import { getPayoutTypes } from '@/constants/payout-types'

export default {
    data () {
        return {
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            showComment: false,
            loading_employees: false,
            loading_types: false,
            rules: {
                required: value => !!value || 'Required field.',
                required_numeric: value => !!value || 'Required field. Numeric Only',
                max_amount: value => value<=100000 || 'Invalid Amount. Maximum of 100,000.00',
                max_months_to_pay: value => value<=120 || 'Maximum of 120 months (10 years) to pay only.',
            },            
            mode: '',
            payment_terms: [
                {paymentTerm: 1, description: '1 month'},
                {paymentTerm: 2, description: '2 months'},
                {paymentTerm: 3, description: '3 months'},
                {paymentTerm: 4, description: '4 months'},
                {paymentTerm: 5, description: '5 months'},
                {paymentTerm: 6, description: '6 months'},
                {paymentTerm: 7, description: '7 months'},
                {paymentTerm: 8, description: '8 months'},
                {paymentTerm: 9, description: '9 months'},
                {paymentTerm: 10, description: '10 months'},
                {paymentTerm: 11, description: '11 months'},
                {paymentTerm: 12, description: '12 months'},
            ],
            calculation_types: [
                {calculationType: 1, description: 'Number of months to pay', hint: ''},
                {calculationType: 2, description: 'Monthly deduction amount', hint: ''}
            ],
            payment_start_cutoff: [
                { cutOff: 1, description: '1st CutOff' },
                { cutOff: 2, description: '2nd CutOff' }
            ],
            paymentCutOffStart: null,
            calculationType: null,
            menuPaymentStart: false,
            cashAdvancesId: null,
            totalAmount: null,
            paymentTerms: null,
            paymentStart: null,
            monthlyDeductionAmount: null,
            cashAdvanceTypeId: null,
            deductionMode: null,
            description: "",
            cashadvances_types: [],
            employees: [],
            cutoff_setting: null,
            isRequestForOtherUser: null,
            requestForUserId: null,
            pageKey: null
        }
    },
    methods: {
        allowedDates(val) {
            const oneMonthEarlier = this.$moment().subtract(1, 'month').startOf('month');
            const selectedMonth = this.$moment(val).startOf('month');
            return selectedMonth.isSameOrAfter(oneMonthEarlier);
        },
        async getEmployees() {
            try {
                this.loading_employees = true
                this.employees = []
                const response = await employeeApi.getAllByPageKey(pageKeys.cash_advances)
                if (response && response.status == 200) {
                    const members = response.data.employees
                    members.forEach(item => {
                        this.employees.push({
                            userId: item.userId,
                            name: item.firstName + " " + item.lastName,
                            avatar: awsS3Helper.getAvatarUrl(item.userId),
                            group: item.team
                        })
                    })
                }
                this.loading_employees = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        async addUpdate() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate()) {
                    var data = {
                        cashAdvancesId: this.cashAdvancesId,
                        isRequestForOtherUser: this.isRequestForOtherUser,
                        requestForUserId: this.requestForUserId,
                        totalAmount: this.totalAmount,
                        paymentTerms: this.paymentTerms,
                        calculationType: this.calculationType,
                        paymentCutOffStart: this.paymentCutOffStart,
                        monthlyDeductionAmount: this.monthlyDeductionAmount,
                        paymentStart: this.paymentStart,
                        cashAdvanceTypeId: this.cashAdvanceTypeId,
                        deductionMode: this.isBiMonthlyCutoff ? this.deductionMode : 1,
                        description: this.description
                    }
                    var response = null
                    if (this.mode == 'Add')
                        response = await cashadvancesApi.add(data, this.pageKey)
                    else
                        response = await cashadvancesApi.update(data, this.pageKey)
                        
                    if (response.status == 200) {
                        this.$emit('send', response.data)
                        this.closeDialog()
                    }
                }
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setAdd(data) {
            this.mode = 'Add'
            this.isRequestForOtherUser = data.isRequestForOtherUser
            this.pageKey = data.pageKey

            if (this.isRequestForOtherUser && this.employees.length==0) await this.getEmployees()
            if (this.cashadvances_types.length==0) await this.getTypes()
            if (this.cutoff_setting == null) await this.getCuttoffSettings()
        },
        async setUpdate(data, pageKey) {
            this.mode = 'Update'
            this.pageKey = pageKey
            this.isRequestForOtherUser = data.isRequestForOtherUser

            if (this.cashadvances_types.length==0) await this.getTypes()
            if (this.cutoff_setting == null) await this.getCuttoffSettings()

            this.cashAdvancesId = data.cashAdvancesId
            this.totalAmount = data.totalAmount
            this.monthlyDeductionAmount = data.monthlyDeductionAmount
            this.paymentTerms = data.paymentTerms
            this.calculationType = data.calculationType
            this.paymentCutOffStart = data.paymentCutOffStart
            this.paymentStart = this.$moment(data.paymentStart).format('YYYY-MM')
            this.cashAdvanceTypeId = data.cashAdvanceTypeId
            this.deductionMode = data.deductionMode
            this.description = data.description
        },
        async getCuttoffSettings() {
            try {
                this.disabled = true
                this.loading = true
                const response = await cutoffApi.getSettings()
                if (response && response.status == 200) {
                    this.cutoff_setting = response.data.item
                }
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getTypes() {
            try {
                this.disabled = true
                this.loading_employees = true
                const response = await cashadvancesApi.getTypes()
                if (response && response.status == 200) {
                    this.cashadvances_types = response.data.items
                }
                this.loading_employees = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogAddEdit', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.remarks = ''
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
    },
    computed: {
        getPayoutTypes() {
            return getPayoutTypes(this.isBiMonthlyCutoff)
        },
        isBiMonthlyCutoff() {
            if (this.cutoff_setting) {
                return this.cutoff_setting.type === "2"
            }
        },
    },
    created() {}
}
</script>
<style scoped>
.form-container {
    padding:10px 20px 0px 20px;
}
.form-row {
    padding: 0px 20px 0px 20px;
}
</style>